import PropTypes from 'prop-types';

const VARIANT_CLASS = {
  listWithSide: 'layout-shell--listWithSide',
  form: 'layout-shell--form',
  formTall: 'layout-shell--formTall',
  detail: 'layout-shell--detail',
};

/**
 * 頁面高度外殼，統一 calc(100vh - chrome)。
 *
 * @see docs/UI_LAYOUT.md
 */
const PageShell = ({ variant = 'listWithSide', children, className = '' }) => {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.listWithSide;

  return (
    <div className={`layout-shell ${variantClass} ${className}`.trim()}>
      {children}
    </div>
  );
};

PageShell.propTypes = {
  variant: PropTypes.oneOf(['listWithSide', 'form', 'formTall', 'detail']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PageShell;
